$(function () {
    $('[data-component="shopsNavigation"]').on('click', function () {
        let $that = $(this);
        let target = $(this).data('target');
        let $target = $(target);

        if ($target.hasClass('isActive')) {
            $that.removeClass('isActive');
            $target.removeClass('isActive').slideUp(150);
        } else {
            $that.addClass('isActive');
            $target.addClass('isActive').slideDown(150);
        }
    })
});